const DashboardMode = {
  JOBS: "jobs",
  REQUESTS: "requests",
};

export default DashboardMode;
